import React from "react";
import GenericTree from "../../../../../core/GenericTree";
import ComponentHeader from "../../../../../core/ComponentHeader";
import { labels } from "../../../../../../localization/labels";

const Classification = ({
  data,
  loadedKeys,
  loadData,
  onClick,
  draggable,
  pageInfo,
  onPageNumberClick,
  onSearchChange,
  treeRef,
  onActiveButtonChange,
  activeValue,
  searchValue,
  handleShow
}) => {
  return (
    <div className="distance-from-tab">
      <div>
        <ComponentHeader
          title={labels.classification}
          onAdd={handleShow}
          activeFilter={activeValue}
          onActiveFilterChange={onActiveButtonChange}
          onSearchChange={onSearchChange}
          searchValue={searchValue}
        />
      </div>
      <div className="bordered_bottom_rounded">
        <GenericTree
          ref={treeRef}
          data={data}
          loadData={loadData}
          draggable={draggable}
          onClick={onClick}
          pageInfo={pageInfo}
          onPageNumberClick={onPageNumberClick}
          loadedKeys={loadedKeys}
        />
      </div>
    </div>
  );
};

export default Classification;
